import {Component, EventEmitter, Input, Output} from '@angular/core';
import {UbgZifferStructured} from '../../../../model/ziffer_structured';
import {UbgLine} from '../../../../model/line';
import {MediaChange, MediaObserver} from '@angular/flex-layout';
import {UbgZifferService} from '../../../../services/ziffer.service';
import {TextHelperService} from '../../../../services/helpers/text-helper.service';
// import * as InlineEditor from '@ckeditor/ckeditor5-build-inline';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-leitantrag-ziffer-editable',
  templateUrl: './leitantrag-ziffer-editable.component.html',
  styleUrls: ['./leitantrag-ziffer-editable.component.scss']
})
export class LeitantragZifferEditableComponent {

  @Input() set ziffer(ziffer: UbgZifferStructured) {
    this.zifferService.getLines(ziffer).then((response: Array<UbgLine>) => {
      this.lines = response;
      if (!this.hasProposalContent) {
        this.setContent(response);
      }
    });
  }
  @Input() set proposal(proposalContent) {
    if (proposalContent) { // when user wants to edit a proposal
      this.hasProposalContent = true;
      this.content = this.textHelperService.fixTags(this.textHelperService.dropStyling(proposalContent));
    }
  }
  lines: Array<UbgLine>;
  zifferClass: string = 'ubg-ziffer-line';
  content: string;
  hasProposalContent = false;
  margin = [];

  public Editor = ClassicEditor;
  public Config = {
    language: 'de',
    toolbar: [
      /*      'heading',
            '|',*/
      'bold',
      'italic',
      'underline',
      '|',
      'bulletedList',
      'numberedList',
      '|', 'alignment:left', 'alignment:right', 'alignment:center', 'alignment:justify',
      'subscript', 'superscript',
      '|',
      'undo',
      'redo',
    ]
  };

  constructor(private mediaObserver: MediaObserver,
              private zifferService: UbgZifferService,
              private textHelperService: TextHelperService
  ) {
    this.mediaObserver.media$.subscribe((change: MediaChange) => {
      this.zifferClass = 'ubg-ziffer-line ubg-ziffer-line-' + change.mqAlias;
    });
  }


  setContent(lines) {
    this.content = '';
    this.margin = [];
    for (let i = 0; i < lines.length; i++) {
      // we are marking every line so that we can split the content to the lines again @TODO doesn't work because ckeditor is an asshole
      // this.content += '<span id="' + lines[i].attributes.number + '">' + lines[i].attributes.content.value + '</span>';
      this.content += lines[i].attributes.content.value;
      // placing margin before and after lists in numbers so it stays aligned with the text
      if (lines[i].attributes.content.value.includes('<ol>') ||
        lines[i].attributes.content.value.includes('<ul>') ) {
        this.margin.push(lines[i].attributes.number * 1);
      }
      if (lines[i].attributes.content.value.includes('</ol>') ||
        lines[i].attributes.content.value.includes('</ul>')) {
        this.margin.push( (lines[i].attributes.number * 1) + 1  );
      }
    }
/*    console.log('the content');
    console.log(this.content);*/
  }

  getContent () {
    return this.content;
  }
}
